document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.getElementById("StickyAddToCart");
  if (!stickyBar) return;

  const buyButtons = document.querySelector(".product-form__buttons");
  const footer = document.querySelector("footer");
  let isVisible = false;
  let isFooterVisible = false;
  let isBuyButtonsVisible = false;
  let isAboveBuyButtons = true;
  const DESKTOP_WIDTH = 750;
  
  // Flag to prevent infinite loops during synchronization
  let isSyncing = false;

  // Function to sync variant selection without triggering events
  function syncVariantSelection(
    sourceElement,
    targetElements,
    isRadio = false,
  ) {
    const value = sourceElement.value;
    const optionIndex = sourceElement.dataset.optionIndex;
    const optionName = sourceElement.name;

    targetElements.forEach((element) => {
      if (isRadio) {
        if (element.value === value && element.name === optionName) {
          element.checked = true;
        }
      } else {
        if (
          element.dataset.optionIndex === optionIndex ||
          element.name === optionName
        ) {
          element.value = value;
        }
      }
    });
  }

  // Get all variant selection elements
  const mainFormSelects = document.querySelectorAll("variant-selects select");
  const mainFormRadios = document.querySelectorAll(
    'variant-radios input[type="radio"]',
  );
  const stickySelects = document.querySelectorAll(".sticky-add-to-cart select");

  // Function to find radio button by option name and value (works with variant-radios structure)
  function findRadioByOptionAndValue(optionName, value) {
    // First try the variant-radios structure (fieldsets)
    const variantRadios = document.querySelector("variant-radios");
    if (variantRadios) {
      const fieldsets = Array.from(variantRadios.querySelectorAll("fieldset"));
      for (const fieldset of fieldsets) {
        const legend = fieldset.querySelector("legend");
        if (legend && legend.textContent.trim() === optionName) {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.value === value
          );
        }
      }
    }

    // Fallback to the original pattern (direct name matching)
    return Array.from(mainFormRadios).find(
      (radio) => radio.name === optionName && radio.value === value,
    );
  }

  // Function to find all radios for a specific option name
  function findRadiosByOption(optionName) {
    // First try the variant-radios structure (fieldsets)
    const variantRadios = document.querySelector("variant-radios");
    if (variantRadios) {
      const fieldsets = Array.from(variantRadios.querySelectorAll("fieldset"));
      for (const fieldset of fieldsets) {
        const legend = fieldset.querySelector("legend");
        if (legend && legend.textContent.trim() === optionName) {
          return Array.from(fieldset.querySelectorAll("input"));
        }
      }
    }

    // Fallback to the original pattern (direct name matching)
    return Array.from(mainFormRadios).filter(
      (radio) => radio.name === optionName,
    );
  }

  // Prevent form submission on select changes
  stickySelects.forEach((select) => {
    select.addEventListener("change", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  // Sync from main form selects to sticky bar and radios
  mainFormSelects.forEach((select) => {
    select.addEventListener("change", (e) => {
      // Skip if we're already syncing to prevent loops
      if (isSyncing) return;
      
      isSyncing = true;
      
      try {
        // Sync with sticky selects
        syncVariantSelection(select, stickySelects);

        // Sync with radio buttons
        const optionName = select.name.replace("options[", "").replace("]", "");
        const matchingRadios = findRadiosByOption(optionName);
        syncVariantSelection(select, matchingRadios, true);

        // Update variant ID after syncing
        updateVariantId();
      } finally {
        isSyncing = false;
      }
    });
  });

  // Sync from main form radios to sticky bar and selects
  mainFormRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      // Skip if we're already syncing to prevent loops
      if (isSyncing) return;
      
      if (radio.checked) {
        isSyncing = true;
        
        try {
          // Get option name - for variant-radios, we need to find the fieldset legend
          let optionName = radio.name;
          
          // If this is a variant-radios radio, get the option name from the fieldset legend
          const fieldset = radio.closest("fieldset");
          if (fieldset) {
            const legend = fieldset.querySelector("legend");
            if (legend) {
              optionName = legend.textContent.trim();
            }
          }
          
          // Find corresponding sticky select by option name
          const stickySelect = Array.from(stickySelects).find((select) => {
            const selectName = select.name
              .replace("options[", "")
              .replace("]", "");
            return selectName === optionName;
          });

          if (stickySelect) {
            stickySelect.value = radio.value;
          }

          // Sync with main form selects
          const mainFormSelect = Array.from(mainFormSelects).find((select) => {
            const selectName = select.name
              .replace("options[", "")
              .replace("]", "");
            return selectName === optionName;
          });

          if (mainFormSelect) {
            mainFormSelect.value = radio.value;
          }

          // Update variant ID after syncing
          updateVariantId();
        } finally {
          isSyncing = false;
        }
      }
    });
  });

  // Function to get variant data from either variant-selects or variant-radios
  function getVariantData() {
    // Try variant-selects first
    let variantElement = document.querySelector("variant-selects");
    
    // If not found, try variant-radios
    if (!variantElement) {
      variantElement = document.querySelector("variant-radios");
    }
    
    if (!variantElement) return null;

    const variantDataScript = variantElement.querySelector('[type="application/json"]');
    if (!variantDataScript) return null;

    try {
      return JSON.parse(variantDataScript.textContent);
    } catch (e) {
      console.error("Failed to parse variant data:", e);
      return null;
    }
  }

  // Function to get current option values (mirrors variant-radios updateOptions logic)
  function getCurrentOptions() {
    // Try to get options from variant-radios first (using fieldsets)
    const variantRadios = document.querySelector("variant-radios");
    if (variantRadios) {
      const fieldsets = Array.from(variantRadios.querySelectorAll("fieldset"));
      return fieldsets.map((fieldset) => {
        const checkedRadio = Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        );
        return checkedRadio ? checkedRadio.value : null;
      }).filter(value => value !== null);
    }

    // Fallback to variant-selects
    const variantSelects = document.querySelector("variant-selects");
    if (variantSelects) {
      return Array.from(variantSelects.querySelectorAll("select")).map((select) => select.value);
    }

    // Final fallback to main form selects
    return Array.from(mainFormSelects).map((select) => select.value);
  }

  // Function to update variant ID based on current selections
  function updateVariantId() {
    const variantData = getVariantData();
    if (!variantData) return;

    // Get current option values using the same logic as variant-radios
    const currentOptions = getCurrentOptions();

    // Find matching variant
    const currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return currentOptions[index] === option;
        })
        .includes(false);
    });

    if (currentVariant) {
      // Update the hidden ID field in all product forms without triggering events
      const productForms = document.querySelectorAll('[id^="product-form-"]');
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input && input.value !== currentVariant.id.toString()) {
          input.value = currentVariant.id;
          // Only dispatch event if we're not currently syncing to avoid loops
          if (!isSyncing) {
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      });
    }
  }

  // Sync from sticky bar to main form selects and radios
  stickySelects.forEach((select) => {
    select.addEventListener("change", (e) => {
      // Skip if we're already syncing to prevent loops
      if (isSyncing) return;
      
      isSyncing = true;
      
      try {
        // Get the option name without the "options[]" wrapper
        const optionName = select.name.replace("options[", "").replace("]", "");

        // Find and update main form select
        const mainFormSelect = Array.from(mainFormSelects).find((mainSelect) => {
          const mainSelectName = mainSelect.name
            .replace("options[", "")
            .replace("]", "");
          return mainSelectName === optionName;
        });

        if (mainFormSelect) {
          mainFormSelect.value = select.value;
        }

        // Find and update radio button using the helper function
        const mainFormRadio = findRadioByOptionAndValue(optionName, select.value);

        if (mainFormRadio) {
          mainFormRadio.checked = true;
        }

        // Update the variant ID after syncing options
        updateVariantId();
      } finally {
        isSyncing = false;
      }
    });
  });

  // Function to update sticky bar visibility
  function updateStickyBarVisibility() {
    const isDesktop = window.innerWidth > DESKTOP_WIDTH;

    if (isDesktop) {
      // On desktop, only show when scrolled past the buy buttons and they're not visible
      if (!isBuyButtonsVisible && !isFooterVisible && !isAboveBuyButtons && !isVisible) {
        stickyBar.classList.add("visible");
        isVisible = true;
      } else if ((isBuyButtonsVisible || isFooterVisible || isAboveBuyButtons) && isVisible) {
        stickyBar.classList.remove("visible");
        isVisible = false;
      }
    } else {
      // On mobile, show whenever buy buttons are not visible (original behavior)
      if (!isBuyButtonsVisible && !isFooterVisible && !isVisible) {
        stickyBar.classList.add("visible");
        isVisible = true;
      } else if ((isBuyButtonsVisible || isFooterVisible) && isVisible) {
        stickyBar.classList.remove("visible");
        isVisible = false;
      }
    }
  }

  // Check if we're above the buy buttons
  function updateScrollPosition() {
    if (buyButtons) {
      const buyButtonsRect = buyButtons.getBoundingClientRect();
      isAboveBuyButtons = buyButtonsRect.top > window.innerHeight;
      updateStickyBarVisibility();
    }
  }

  // Show/hide sticky bar based on visibility
  const buyButtonsObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isBuyButtonsVisible = entry.isIntersecting;
        updateStickyBarVisibility();
      });
    },
    { threshold: 0 }
  );

  const footerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isFooterVisible = entry.isIntersecting;
        updateStickyBarVisibility();
      });
    },
    { threshold: 0 }
  );

  // Listen for scroll events to update position relative to buy buttons
  window.addEventListener("scroll", updateScrollPosition, { passive: true });

  // Listen for resize events to handle desktop/mobile transitions
  window.addEventListener("resize", updateStickyBarVisibility, { passive: true });

  // Initial setup
  if (buyButtons) {
    buyButtonsObserver.observe(buyButtons);
    updateScrollPosition();
  }

  if (footer) {
    footerObserver.observe(footer);
  }

  // Initialize variant ID on page load
  updateVariantId();
});
